/**
 * Document text statistics (word count, reading time).
 *
 * Lives in shared rather than the web app because the OG card renderer in
 * apps/api shows the same numbers as the editor status bar — if the two
 * diverged, a shared link would advertise a different word count than the
 * document it points at.
 */
import { stripFrontmatter } from './frontmatter.js';

export interface TextStats {
  words: number;
  chars: number;
  /** Estimated reading time in minutes (>=1). */
  readingMinutes: number;
}

const WORDS_PER_MINUTE = 200;

export function computeStats(input: string): TextStats {
  // Frontmatter is metadata, not prose — counting it would inflate every stat
  // the moment a note grows a tag.
  const text = stripFrontmatter(input);
  const chars = text.length;
  const words = (text.trim().match(/\S+/g) ?? []).length;
  const readingMinutes = Math.max(1, Math.round(words / WORDS_PER_MINUTE));
  return { words, chars, readingMinutes };
}
